<template>
  <div class="box">
    <hearderCommon :text="text"></hearderCommon>
    <div class="login">
      <!-- 文字 -->
      <div class="loginTitle">重置密码</div>
      <!-- 登录表单 -->
      <van-cell-group class="group">
        <van-field
          v-model="username"
          placeholder="请输入新密码"
          @blur="reg"
          class="group_phon"
          type="password"
        />
        <van-field
          v-model="password"
          center
          clearable
          type="password"
          placeholder="请确认新密码"
          @blur="word"
          class="group_word"
        ></van-field>
        <button class="login-form-button" @click="login">完成并登录</button>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
export default {
  components: {
    hearderCommon
  },
  data() {
    return {
      username: "",
      password: "",
      text: "取消",
      patt: /^1[0-9]{10}$/,
      companyId: "",
      code: "",
      mobile: ""
    };
  },

  created() {
    localStorage.removeItem("token");
    this.companyId = this.$route.query.companyId;
    this.code = this.$route.query.code;
    this.mobile = this.$route.query.mobile;
  },
  methods: {
    // 修改密码
    login() {
      this.companyId = this.companyId || 1;
      if (this.password !== this.username) {
        this.$toast("两次密码不一致");
      } else {
        this.$axios
          .get(
            `/customer/customerContact/resetPassword?code=${
              this.code
            }&companyId=${this.companyId}&mobile=${this.mobile}&password=${
              this.password
            }`
          )
          .then(res => {
            if (res.data.code == 0) {
              this.$router.push({
                path: "/accountLogin",
                query: { companyId: this.companyId }
              });
            }
          });
      }
    },
    // 校验密码
    reg() {
      if (this.username === "") {
        this.$toast("请输入密码");
      } else if (this.username.length < 6 || this.username.length > 12) {
        this.$toast("请输入6~12位密码");
      }
    },
    // 确认密码
    word() {
      if (this.password !== this.username) {
        this.$toast("两次密码不一致");
      }
    }
  }
};
</script>

<style scoped>
.box {
  padding-top: 1px;
  /* background: #fff; */
  background: url("../../assets/登录.png") center center repeat;
  height: 99%;
}
.login {
  width: 60%;
  height: 80%;
  margin: 15% auto 0;
}
.title {
  font-size: 25px;
  font-weight: 700;
  height: 10%;
  padding-left: 7%;
  color: rgba(51, 51, 51, 1);
}
.login-form-button {
  width: 89%;
  border: 0;
  border-radius: 50px;
  line-height: 30px;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 10px;
}
.protocol {
  color: rgba(116, 180, 43, 1);
  text-decoration: underline;
  font-size: 12px;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.box >>> .header {
  background-color: transparent !important;
}
</style>